import { Button } from '@/components/button/Button'

export default function TableQueryFooter({
  onClear,
  onCancel,
  onApply,
  applyDisabled = false,
}: {
  onClear: () => void
  onCancel: () => void
  onApply?: () => void
  applyDisabled?: boolean
}) {
  return (
    <div className="-mx-4 -mb-4 -mt-3 flex items-center gap-2 border-t border-brand-neutral-200 px-4 py-4">
      <Button type="button" size="sm" color="destructive" variant="plain" onClick={onClear}>
        Clear
      </Button>
      <div className="flex-1" />
      <Button type="button" size="sm" color="primary" variant="outlined" onClick={onCancel}>
        Cancel
      </Button>
      <Button type={onApply ? 'button' : 'submit'} size="sm" color="primary" variant="filled" disabled={applyDisabled} onClick={onApply}>
        Apply
      </Button>
    </div>
  )
}
